import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import Page from 'modules/Page';
import { i18n } from 'i18n';
import * as parentConstants from 'modules/project/BinderDeliveriesPage/constants';
import * as constants from './constants';

const NewBinderDeliveryPage = lazyWithSuspense(() => import('modules/project/NewBinderDeliveryPage/NewBinderDeliveryPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: makePage({
    WrappedPage: NewBinderDeliveryPage,
    titleFn: () => i18n._(constants.TITLE),
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
  }),
};

export default page;
